import '@samc/icons/css/materialdesignicons.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import '@samc/auth-authentication-okta/index.css';
import '@samc/auth-authorization/index.css';
import '@mbms/liftsiftstyles/dist/index.css';
import '../wwwroot/css/app.css';


// Add in the polyfill
import './polyfill';

// Register some vue plugins
import '@/registerVuePlugins';

// Set the active nav item
import { setActiveNav } from './nav';
document.addEventListener('DOMContentLoaded', (e) => {
  setActiveNav();
});